import { render, staticRenderFns } from "./block-redirect.vue?vue&type=template&id=ce173984&scoped=true"
import script from "./block-redirect.vue?vue&type=script&lang=js"
export * from "./block-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce173984",
  null
  
)

export default component.exports